<template>
    <div class="content">

        <div class="box" style="margin-bottom: 10px;" v-if="successList?.length > 0">
            <div class="tip">以下成员获取企微ID成功：</div>
            <P style="color: #67C23A;">
                {{ successList }}
            </P>
        </div>
        <div class="box" v-if="errorList?.length > 0">
            <div class="tip">以下成员获取企微ID失败：</div>
            <P style="color: #F56C6C;">
                {{ errorList }}
            </P>
        </div>
        <div class="btns">
            <el-button type="primary" @click="handleClose">确定</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['cbs', 'errorList', 'successList'],
    data() {
        return {}
    },
    methods: {
        delRepeatData(list) {
            return [...new Set([...list])].join('、')
        },
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    max-height: 300px;
    overflow-y: auto;
}

.btns {
    margin-top: 25px;
    text-align: right;
}

.content {
    max-height: 600px;

    p {
        margin: 4px 0;
    }

    span {
        padding-left: 20px;
        display: block;
    }
}
</style>